/* global axios */
import ApiClient from './ApiClient';

const idempotencyConfig = idempotencyKey => {
  if (!idempotencyKey) return undefined;
  return { headers: { 'Idempotency-Key': idempotencyKey } };
};

const isOpenBoletoEmptyState = error =>
  error?.response?.status === 404 &&
  error?.response?.data?.error === 'sem_boleto_em_aberto';

class FinanceiroAPI extends ApiClient {
  constructor() {
    super('financeiro', { accountScoped: true });
  }

  resumo() {
    return axios.get(`${this.url}/resumo`);
  }

  cobrancas() {
    return axios.get(`${this.url}/cobrancas`);
  }

  historico(params = {}) {
    return axios.get(`${this.url}/historico`, { params });
  }

  fecharPeriodo(payload = {}) {
    return axios.post(`${this.url}/fechar_periodo`, payload);
  }

  cobranca(params = {}) {
    return axios.get(`${this.url}/cobranca`, { params });
  }

  consultarBoletoAberto(payload = {}) {
    return axios.post(`${this.url}/cobranca/boleto`, payload).catch(error => {
      if (isOpenBoletoEmptyState(error)) {
        return {
          data: null,
          empty: true,
          emptyReason: 'sem_boleto_em_aberto',
        };
      }

      throw error;
    });
  }

  comissoes(params = {}) {
    return axios.get(`${this.url}/comissoes`, { params });
  }

  comissoesReconciliacao(params = {}) {
    return axios.get(`${this.url}/comissoes/reconciliacao`, { params });
  }

  marcarComissaoPayable(poolId, payload = {}) {
    return axios.post(
      `${this.url}/comissoes/pools/${poolId}/payable`,
      payload,
      idempotencyConfig(payload.idempotency_key)
    );
  }

  marcarComissaoPaid(poolId, payload = {}) {
    return axios.post(
      `${this.url}/comissoes/pools/${poolId}/paid`,
      payload,
      idempotencyConfig(payload.idempotency_key)
    );
  }

  comissoesExportUrl(params = {}) {
    const query = new URLSearchParams(
      Object.entries(params).filter(
        ([, value]) => value != null && value !== ''
      )
    ).toString();
    return `${this.url}/comissoes/export?${query}`;
  }

  fecharComissoes(payload = {}) {
    return axios.post(`${this.url}/comissoes/fechar`, payload);
  }

  reabrirComissoes(payload = {}) {
    return axios.post(`${this.url}/comissoes/reabrir`, payload);
  }

  definirMetaComissao(payload = {}) {
    return axios.post(`${this.url}/comissoes/meta`, payload);
  }

  lancarComissaoManual(payload = {}) {
    return axios.post(`${this.url}/comissoes/manual`, payload);
  }
}

export default new FinanceiroAPI();
